import React from 'react';
import {Typography,
        Box,
        Divider,
        Grid,
        Button,
        Paper, useTheme, useMediaQuery} from '@mui/material';
import DefaultLayout from "../../components/layout/DefaultLayout";
import {useSelector} from "react-redux";

const documentsEntreprise = [
    {
        title: 'Certificat médical',
        updated: '17 mai 2024',
        downloads: '1,973',
        path: 'https://www.uniprevoyance.fr/download/certificat-medical/?wpdmdl=30458&refresh=6784dc1b83b4b1736760347',
    },
    {
        title: 'Déclaration d’arrêt de travail Inter Pro',
        updated: '30 avril 2024',
        downloads: '811',
        path:'https://www.uniprevoyance.fr/download/avis-dinterruption-de-travail-inter-pro/?wpdmdl=30456&refresh=6784dc1b87b7e1736760347',
    },
    {
        title: 'Déclaration de décès Inter Pro',
        updated: '30 avril 2024',
        downloads: '526',
        path: 'https://www.uniprevoyance.fr/download/declaration-de-deces/?wpdmdl=31590&refresh=6784dc1b8b21e1736760347',
    },
    {
        title: 'Déclaration de mise en invalidité Inter Pro',
        updated: '30 avril 2024',
        downloads: '9,262',
        path: 'https://www.uniprevoyance.fr/download/declaration-de-mise-en-invalidite-inter-pro/?wpdmdl=33468&refresh=6784dc1b8f0851736760347',
    },
    {
        title: 'Déclaration de prédécès',
        updated: '30 avril 2024',
        downloads: '9,262',
        path: 'https://www.uniprevoyance.fr/download/declaration-de-predeces/?wpdmdl=35023&refresh=6784dc1b933341736760347',
    },
    {
        title: 'Guide des services entreprises',
        updated: '13 juillet 2021',
        downloads: '9,262',
        path: 'https://www.uniprevoyance.fr/download/guide-des-services-entreprises/?wpdmdl=31041&refresh=6784dc1b987701736760347',
    },
    {
        title: 'LE PRÉLÈVEMENT DES COTISATIONS DSN',
        updated: '22 juin 2023',
        downloads: '9,262',
        path: 'https://www.uniprevoyance.fr/download/le-prelevement-des-cotisations-dsn/?wpdmdl=31814&refresh=6784dc1b9dd141736760347',
    },
    {
        title: 'Note DSN & FAQ',
        updated: '22 juin 2023',
        downloads: '9,262',
        path: 'https://www.uniprevoyance.fr/download/la-dsn/?wpdmdl=31594&refresh=6784dc1ba33951736760347',
    }
];
const documentsAssure = [
    {
        title: 'Certificat médical',
        updated: '17 mai 2024',
        downloads: '1,973',
        path: 'https://www.uniprevoyance.fr/download/certificat-medical/?wpdmdl=30458&refresh=6756f43e756151733751870',
    },
    {
        title: 'Désignation de bénéficiaires',
        updated: '30 avril 2024',
        downloads: '811',
        path:'https://www.uniprevoyance.fr/download/designation-de-beneficiaires/?wpdmdl=30443&refresh=6756f43e79dcc1733751870',
    },
];
const MesDocuments = () => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const account = useSelector(state => state.account);
    const isAssure = account.user.type === 'ASSURE';
    const documentsToDisplay = isAssure ? documentsAssure : documentsEntreprise;
    return (
        <DefaultLayout>
            <Box sx={{p: 2, bgcolor: 'transparent', borderRadius: '8px', width: '100%'}}>
                <Typography variant="h2" sx={{fontWeight: 'bold'}}>
                    Mes documents
                </Typography>
                <Divider   sx={{
                    borderColor: '#EF595D',
                    my: 1,
                    width: '8%',
                    borderWidth: '2px',
                    marginBottom: '15px',
                    marginTop: '15px'
                }} />
                <Typography sx={{ fontSize: '16px' }}>
                    Téléchargez vos documents utiles :
                </Typography>
            </Box>

            <Box sx={{ flexGrow: 1, p: 2 , marginBottom: 10}}>
                <Grid container spacing={2} >
                    <Grid item xs={12} sx={{ display: { xs: 'none', sm: 'block', md: 'block',lg: 'block' } }}>
                        <Paper sx={{ padding: 2 }}>
                            <Grid item xs={12} sx={{ display: { xs: 'none', sm: 'block', md: 'block',lg: 'block' } }}>
                                <Paper >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item md={4} sx={{ mb: 0 }}>
                                            <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                                                Documents
                                            </Typography>
                                        </Grid>
                                        <Grid item md={4} sx={{ mb: 0 }}>
                                            <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                                                Date de mise à jour
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Paper>
                    </Grid>
                    {documentsToDisplay.map((doc, index) => (
                        <Grid item xs={12} key={index}>
                            <Paper sx={{ padding: 2 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4} md={4} lg={4} >
                                        <Typography variant="h5" >{doc.title}</Typography>
                                    </Grid>
                                    <Grid item  xs={12} sm={4} md={4} lg={4} sx={{ ml: '5px' , mr:'-5px'}}>
                                        {doc.updated}
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4} lg={4}>
                                        {isXs ? (
                                            <Button variant="contained"
                                                    color="primary"
                                                    fullWidth={true}
                                                    component="a"
                                                    href={doc.path}
                                                    target="_blank"
                                                    download>
                                                Télécharger
                                            </Button>
                                        ) : (
                                            <Button variant="contained"
                                                    color="primary"
                                                    href={doc.path}
                                                    target="_blank"
                                                    download>
                                                Télécharger
                                            </Button>
                                        )}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </DefaultLayout>
    );
};

export default MesDocuments;
